import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RouteKey } from '../../config/page-key';
import { useUser } from '../../features/user/ssoSlice';
import { useHistory } from 'react-router-dom';
import {  resetRemoteSignIn, logout } from '../../features/user/ssoSlice';
import { Loading } from '../../components/loading/Loading';

const Logout = props => {
  const dispatch = useDispatch();
  const user = useUser();
	const history = useHistory();
	const [redirectUrl, setRedirectUrl] = useState(undefined);
  
  const keycloakConfig = user?.auth?.keycloakConfig;

  const PageLoader = () => (
    <div
      style={{
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Loading />
    </div>
  );


  useEffect(() => {
    if (!user) return;
    let url = RouteKey.SSO;
    if (keycloakConfig != null) {
      if (window.keycloak?.logout) {
        if (!history.location?.state?.forceLogoff) {
          if (history.location?.state?.type) {
            
            url += `?realm=${keycloakConfig.realm}&logoutType=` + history.location?.state?.type;
          }
          else {
            url += `?realm=${keycloakConfig.realm}&logoutType=1`;
          }
        }
      }
    }
    setRedirectUrl(url);
    dispatch(logout());
    dispatch(resetRemoteSignIn());

    if (keycloakConfig != null && window.keycloak?.logout) {
      window.keycloak.logout({
        redirectUri: window.location.origin + url
      });
    }
  }, []);

  if (redirectUrl == null) {
    return <PageLoader />;
  }
  return <Redirect to={redirectUrl} />;
};

export default Logout;
